exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll[data-v-100b0462]{\n\toverflow-x:auto;\n}\nbutton[data-v-100b0462]{\n\tposition:absolute;\n\ttop:0px;\n\tright:0px;\n\theight:30px;\n\tmargin:2px;\n}\n.legend[data-v-100b0462]{\n\tposition:absolute;\n\ttop:35px;\n\tright:0px;\n\tborder:1px solid black;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-100b0462","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/chart.vue
// module id = 844
// module chunks = 0